import { Link } from 'react-router-dom';
import { PageHero } from '../components/ui/PageHero';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { SUPPORT_INFO, CONTACT_EMAIL } from '../constants/content';
import { mailtoLink } from '../constants/navigation';

export default function SupportPage() {
  return (
    <>
      <PageHero
        title="技术支持"
        subtitle="APP 故障、设备连接、功能异常等问题，均可通过官方渠道获取专业技术协助。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '技术支持' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-16">
          {[
            { icon: 'fa-clock-o', title: '响应时效', desc: SUPPORT_INFO.responseTime },
            { icon: 'fa-globe', title: '服务语言', desc: SUPPORT_INFO.languages },
            { icon: 'fa-shield', title: '数据安全', desc: SUPPORT_INFO.security },
          ].map((item) => (
            <AnimatedCard
              key={item.title}
              className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-purple-500/20 text-center"
            >
              <i className={`fa ${item.icon} text-3xl text-secondary mb-3`} />
              <h3 className="font-semibold mb-1">{item.title}</h3>
              <p className="text-purple-300 text-sm">{item.desc}</p>
            </AnimatedCard>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16">
          <AnimatedCard className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-purple-500/20">
            <div className="w-12 h-12 rounded-xl bg-secondary/20 flex items-center justify-center mb-4">
              <i className="fa fa-cogs text-secondary text-xl" />
            </div>
            <h2 className="text-xl font-semibold mb-4">支持范围</h2>
            <ul className="space-y-3 text-purple-200 text-sm">
              {SUPPORT_INFO.scope.map((text) => (
                <li key={text} className="flex items-start">
                  <i className="fa fa-angle-right text-secondary mr-2 mt-0.5" />
                  {text}
                </li>
              ))}
            </ul>
          </AnimatedCard>

          <AnimatedCard className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-purple-500/20">
            <div className="w-12 h-12 rounded-xl bg-secondary/20 flex items-center justify-center mb-4">
              <i className="fa fa-life-ring text-secondary text-xl" />
            </div>
            <h2 className="text-xl font-semibold mb-4">提交问题方式</h2>
            <p className="text-purple-200 mb-4 text-sm leading-relaxed">
              请将问题描述、设备型号、系统版本、APP 版本号发送至官方邮箱，我们将在 1-2
              个工作日内回复处理。
            </p>
            <p className="text-purple-300 text-xs mb-4">
              建议附上截图或录屏，以便我们更快定位问题。
            </p>
            <a
              href={mailtoLink('Ameowzing 技术支持')}
              className="inline-flex items-center text-secondary font-semibold text-lg hover:underline"
            >
              <i className="fa fa-envelope-o mr-2" /> {CONTACT_EMAIL}
            </a>
          </AnimatedCard>
        </div>

        <div className="max-w-3xl mx-auto mb-16">
          <h2 className="text-2xl font-bold mb-8 text-center">常见问题自助排查</h2>
          <div className="space-y-6">
            {SUPPORT_INFO.troubleshooting.map((item) => (
              <AnimatedCard
                key={item.problem}
                className="bg-white/5 rounded-2xl p-6 border border-purple-500/20"
              >
                <h3 className="font-semibold text-secondary mb-3">{item.problem}</h3>
                <ol className="space-y-2">
                  {item.steps.map((step, index) => (
                    <li key={step} className="flex items-start text-purple-200 text-sm">
                      <span className="text-purple-400 mr-3 shrink-0">{index + 1}.</span>
                      {step}
                    </li>
                  ))}
                </ol>
              </AnimatedCard>
            ))}
          </div>
        </div>

        <div className="text-center">
          <p className="text-purple-200 mb-4">更多问题请查阅 FAQ 或使用教程</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/faq"
              className="inline-flex justify-center items-center bg-white/10 border border-purple-500/30 px-6 py-2.5 rounded-full hover:bg-white/20"
            >
              常见问题
            </Link>
            <Link
              to="/guide"
              className="inline-flex justify-center items-center bg-white/10 border border-purple-500/30 px-6 py-2.5 rounded-full hover:bg-white/20"
            >
              使用教程
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
